<script lang="ts">
  import type { SerializedHomonym } from '#entities/components/deduplicate/deduplicate_homonyms.svelte'
  import CompactAuthorWorksList from '#entities/components/layouts/compact_author_works_list.svelte'
  import EntityListRow from '#entities/components/layouts/entity_list_row.svelte'
  import MergeAction from '#entities/components/layouts/merge_action.svelte'
  import type { SerializedEntity } from '#entities/lib/entities'
  import type { EntityUri } from '#server/types/entity'

  let {
    entity,
    homonym = $bindable(),
    selectedHomonymsUris = $bindable(),
  }: {
    entity: SerializedEntity
    homonym: SerializedHomonym
    selectedHomonymsUris: EntityUri[]
  } = $props()
</script>

<li class:merged={homonym.merged}>
  <div class="top-row">
    {#if !(entity.isWikidataEntity && homonym.isWikidataEntity)}
      <input type="checkbox" bind:group={selectedHomonymsUris} value={homonym.uri} />
    {/if}
    <EntityListRow
      entity={homonym}
      isUriToDisplay={true}
    />
  </div>
  {#if entity.type === 'human'}
    <CompactAuthorWorksList author={homonym} />
  {/if}
  <div class="action">
    <MergeAction
      fromEntityUri={homonym.uri}
      targetEntityUri={entity.uri}
      bind:homonym
    />
  </div>
</li>

<style lang="scss">
  @import "general/scss/utils";
  li{
    @include display-flex(column, center, center);
    @include radius;
    padding: 0.2em 0.5em;
    margin: 0.3em;
    inline-size: min(26em, 95vw);
    background-color: white;
    :global(.images-collage){
      // keep series covers tight
      inline-size: 7em;
    }
    :global(.images-collage.empty){
      display: none;
    }
    :global(.entity-list-row){
      margin-block-end: 0 !important;
    }
    :global(.entity-details){
      max-block-size: 10em;
      line-height: 1.5rem;
      overflow-y: auto;
    }
  }
  .merged{
    // Hide without removing from the document flow, to prevent element jumping
    // and accidental clicks on "merge" buttons
    visibility: hidden;
  }
  .action{
    margin: 0.5em;
  }
  .top-row{
    align-self: stretch;
    @include display-flex(row, flex-start);
    input[type="checkbox"]{
      margin: 0.5em 0;
    }
  }
</style>
